import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "side-info" }
const _hoisted_2 = {
  key: 0,
  class: "contract-name"
}
const _hoisted_3 = { class: "file-name" }
const _hoisted_4 = {
  key: 1,
  class: "thin-divider"
}
const _hoisted_5 = { class: "component-list mt-1" }
const _hoisted_6 = {
  key: 0,
  class: "detail"
}
const _hoisted_7 = {
  key: 1,
  class: "detail"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberIcon = _resolveComponent("NumberIcon")!
  const _component_ValidationTextField = _resolveComponent("ValidationTextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.contractName), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountVars, (component, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }, [
          _createVNode(_component_NumberIcon, {
            number: index + 1
          }, null, 8, ["number"]),
          (component.type == 3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_ValidationTextField, {
                  value: component.isChecked,
                  readonly: true
                }, null, 8, ["value"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_ValidationTextField, {
                  value: component.text,
                  readonly: true
                }, null, 8, ["value"])
              ]))
        ]))
      }), 128))
    ])
  ]))
}